import { render, staticRenderFns } from "./DiagnosisDetailModal.vue?vue&type=template&id=0f591c22&"
import script from "./DiagnosisDetailModal.vue?vue&type=script&lang=js&"
export * from "./DiagnosisDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports